import React from 'react';
import { Link } from 'react-router-dom';
import { BsRobot, BsArrowRight } from 'react-icons/bs';

const AiAutomation = () => {
  return (
    <section className="py-16 sm:py-24 bg-[#fafbfc] text-slate-900 border-b border-slate-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-14 items-center">
          
          {/* Left Column: Heading, Subtitle & Button */}
          <div className="lg:col-span-6 space-y-6" data-aos="fade-right">
            
            {/* Tag */}
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-sm bg-[#f06600]"></span>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
                THE FUTURE IS HERE
              </span>
            </div>

            {/* Title */}
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 tracking-tight leading-[1.15]">
              Harness the Power<br />
              of AI for <span className="text-[#f06600]">Your Business</span>
            </h2>

            {/* Description */}
            <p className="text-slate-600 text-sm sm:text-base leading-relaxed max-w-md">
              We build custom AI solutions that automate tasks, boost productivity and create new opportunities for growth.
            </p>

            {/* Button */}
            <div className="pt-2">
              <Link
                to="/ai-automation"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-slate-300 hover:border-[#f06600] text-slate-800 hover:text-[#f06600] font-semibold text-xs tracking-wide transition-all shadow-sm hover:shadow group"
              >
                <span>Discover AI Solutions</span>
                <BsArrowRight className="text-sm group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>

          </div>

          {/* Right Column: AI Humanoid Graphic with Floating Glass Badges */}
          <div className="lg:col-span-6 relative flex justify-center items-center" data-aos="fade-left">
            <div className="relative w-full max-w-md lg:max-w-lg">
              
              {/* Rounded Robot Visual Container */}
              <div className="rounded-3xl overflow-hidden shadow-2xl border border-slate-200/80 bg-slate-900 relative aspect-[4/3]">
                <img 
                  src="/assets/ai_robot_face.jpg" 
                  alt="AI Humanoid Intelligence" 
                  className="w-full h-full object-cover object-center transform hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>

              {/* Floating Pill Badge 1: Automate Scale Innovate */}
              <div className="absolute bottom-6 left-4 sm:-left-4 bg-white/95 backdrop-blur-md border border-slate-200/90 rounded-2xl py-2.5 px-4 shadow-xl flex items-center gap-2.5 z-20">
                <div className="w-7 h-7 rounded-lg bg-orange-50 text-[#f06600] flex items-center justify-center text-sm">
                  <BsRobot />
                </div>
                <span className="text-xs font-bold text-slate-800 tracking-wide">
                  Automate • Scale • Innovate
                </span>
              </div>

              {/* Floating Card 2: Business Growth +230% with Bar Chart */}
              <div className="absolute top-4 -right-2 sm:-right-6 bg-white/95 backdrop-blur-md border border-slate-200/90 rounded-2xl p-4 shadow-xl z-20 w-36">
                <span className="text-[10px] font-semibold text-slate-400 block">Business Growth</span>
                <div className="text-xl font-extrabold text-slate-900 mt-0.5 tracking-tight">+230%</div>
                
                {/* 5-Bar Chart graphic in Orange */}
                <div className="flex items-end gap-1.5 h-10 mt-2 pt-1">
                  <div className="w-2.5 bg-orange-200 rounded-t h-[30%]"></div>
                  <div className="w-2.5 bg-orange-300 rounded-t h-[45%]"></div>
                  <div className="w-2.5 bg-orange-400 rounded-t h-[65%]"></div>
                  <div className="w-2.5 bg-[#f06600] rounded-t h-[85%]"></div>
                  <div className="w-2.5 bg-[#d05800] rounded-t h-[100%]"></div>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default AiAutomation;
